import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";
import { impactAgentFieldsFragmentDoc } from "gql/apollo/graphql";
import { useHasFeature } from "ui-library/HasFeature";

export const GetImpactAgent = graphql(/* GraphQL */ `
	query GetImpactAgent($params: GetImpactAgentParams!) {
		getImpactAgent(params: $params) {
			...impactAgentFields
		}
	}
`);

export const useGetImpactAgent = (impactAgentId: string) => {
	const hasImpactAgents = useHasFeature("allow_impact_agent");

	const { data, loading, error } = useQuery(GetImpactAgent, {
		variables: {
			params: {
				_id: impactAgentId,
			},
		},
		skip: !impactAgentId || !hasImpactAgents,
	});

	return {
		impactAgent: getFragmentData(
			impactAgentFieldsFragmentDoc,
			data?.getImpactAgent
		),
		loading,
		error,
	};
};
